import type { VenueConfigurationOptionsType as ApiVenueConfigurationOptionsType } from 'src/api/generated/touring/types';
import { mapRecipientGroupMinifiedType } from '../mapRecipientGroupMinifiedType';
import type { VenueConfigurationOptionsType } from '../../types';

export const mapVenueConfigurationOptionsType = (
  api: ApiVenueConfigurationOptionsType
): VenueConfigurationOptionsType => ({
  kind: api.kind,
  venueId: api.venueId,
  recipientGroup:
    api.recipientGroup === null
      ? null
      : mapRecipientGroupMinifiedType(api.recipientGroup),
});
